export function formatCurrency(
  value: number,
  locale = 'en-US',
  currency = 'USD',
  showSymbol = true
) {
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0,
  }).format(value);

  if (!showSymbol) {
    // Remove the currency symbol and any leading/trailing whitespace
    return formatted.replace(/^\$/, '').trim();
  }

  return formatted;
}
